export const RightArrowIcon = () => {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.3333 23.8333C16.1386 23.8337 15.9499 23.7659 15.8 23.6417C15.6296 23.5004 15.5224 23.2971 15.5021 23.0766C15.4817 22.8562 15.55 22.6367 15.6917 22.4667L19.425 18L15.825 13.525C15.6852 13.3528 15.6198 13.1321 15.6432 12.9115C15.6667 12.691 15.7771 12.4889 15.95 12.35C16.1243 12.1966 16.3547 12.1229 16.5856 12.1467C16.8166 12.1704 17.0272 12.2894 17.1667 12.475L21.1917 17.475C21.4444 17.7825 21.4444 18.2258 21.1917 18.5333L17.025 23.5333C16.8555 23.7379 16.5985 23.8493 16.3333 23.8333Z"
        fill="white"
      />
    </svg>
  );
};

export default RightArrowIcon;
